<template>
  <div class="listAction">
    <main class="t-main">
      <ol class="m-breadcrumb">
        <li class="m-breadcrumb__item"><span class="a-text">アクション一覧</span></li>
      </ol>
      <h1 class="a-title">{{ listActionTitle }}</h1>
      <div class="m-form__item-wrapper">
        <button class="a-button" v-on:click="createActionLink">新規登録</button>
      </div>
      <br/>
      <br/>
      <div class="m-form__item-wrapper">
        <div class="m-form__item m-form__item--50">
          <label class="m-form__label">--絞り込み--
            <input class="m-form__input m-form__input--text" type="text" placeholder="Filter..."
                   v-model="searchQuery">
          </label>
        </div>
      </div>
      <br/>
      <div class="a-section">
        <table class="m-table">
          <thead>
          <tr>
            <th>{{ columns.name }}</th>
            <th>{{ columns.type }}</th>
            <th>{{ columns.mtime }}</th>
            <th>{{ columns.utime }}</th>
            <th>{{ columns.delete }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="task in filteredTasks">
            <td>
              <router-link v-bind:to="{ path: 'update-action', query: { actionId: task.actionId}}">{{ task.metadata.name
                }}
              </router-link>
            </td>
            <td>{{ task["metadata"]["type"] }}</td>
            <td>{{ task["mtime"] | moment }}</td>
            <td>{{ task["utime"] | moment }}</td>
            <td><a class="m-form__delete" v-on:click="deleteAction(task)"></a></td>
          </tr>
          </tbody>
        </table>
      </div>
    </main>
  </div>
</template>

<script>
  import store from '../../../stores'
  import moment from 'moment'

  export default {
    name: 'listAction',
    data() {
      const columns = {actionId: 'アクションID', name: 'アクション名', type: '種類', mtime: '作成日時', utime: '更新日時', delete: '削除'}
      return {
        listActionTitle: 'アクション一覧',
        columns,
        searchQuery: ''
      }
    },
    created() {
      store.dispatch('checkSessionId')
      store.dispatch('getActionListData')
    },
    // ajaxで取得してきた
    computed: {
      tasks() {
        return store.state.action.actionList
      },
      filteredTasks() {
        if (!this.searchQuery) return this.tasks
        const regexp = new RegExp(this.searchQuery, 'i')

        return this.tasks.filter(task => {
          return regexp.test(task.metadata.name)
        })
      }
    },
    methods: {
      callActionList: function () {
        store.dispatch('actionList', this.tasks)
      },
      createActionLink: function () {
        this.$router.push('/delivery/create-action')
      },
      deleteAction: function (action) {
        if (confirm(action.actionId + 'のバージョン' + action.versionId + 'を削除しますか？')) {
          store.dispatch('actionDelete', action)
        }
      }
    },
    filters: {
      moment: function (date) {
        return moment(date).format('YYYY/MM/DD HH:mm')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/delivery/action/ListAction.vue